import { useGetCurrentUserQuery } from "@/setup/frontend/api/apiHooks";

export function IfDeveloper({
	children,
	fallback = null,
}: { children: React.ReactNode; fallback?: React.ReactNode }) {
	const userQuery = useGetCurrentUserQuery();
	if (userQuery.data?.roleHasSystemLevelAccess) {
		return children;
	} else {
		return fallback ?? null;
	}
}
